(function() {
  const nav = document.getElementById('rs-nav');
  if (!nav) return;
  const linksContainer = nav.querySelector('.rs-nav-links');
  const nLinks = nav.querySelectorAll('.rs-nav-links a');
  const secs = ['bedienung','mechanik','materialien','wetterschutz','qualitaet','features','nachhaltigkeit','lexikon'];
  const offset = 150;
  let lastActiveLink = null;

  function getSectionTop(el) {
    var rect = el.getBoundingClientRect();
    return rect.top + (window.scrollY || window.pageYOffset);
  }

  function scrollActiveToCenter(activeLink) {
    if (!activeLink || !linksContainer) return;
    requestAnimationFrame(function() {
      var container = linksContainer;
      var linkRect = activeLink.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var linkLeft = linkRect.left - containerRect.left + container.scrollLeft;
      var linkWidth = activeLink.offsetWidth;
      var visibleWidth = container.clientWidth;
      var scrollLeft = linkLeft - (visibleWidth / 2) + (linkWidth / 2);
      var maxScroll = container.scrollWidth - visibleWidth;
      container.scrollTo({
        left: Math.max(0, Math.min(scrollLeft, maxScroll)),
        behavior: 'smooth'
      });
    });
  }

  function updateNav() {
    nav.classList.toggle('visible', (window.scrollY || window.pageYOffset) > 60);
    var cur = '';
    var scrollY = window.scrollY || window.pageYOffset;
    var checkPoint = scrollY + offset;
    for (var i = 0; i < secs.length; i++) {
      var el = document.getElementById(secs[i]);
      if (el) {
        var top = getSectionTop(el);
        var bottom = top + el.offsetHeight;
        if (checkPoint >= top && checkPoint < bottom) {
          cur = secs[i];
          break;
        }
        if (i === secs.length - 1 && checkPoint >= top) cur = secs[i];
      }
    }
    if (!cur && scrollY > 0) {
      for (var j = secs.length - 1; j >= 0; j--) {
        var el2 = document.getElementById(secs[j]);
        if (el2 && checkPoint >= getSectionTop(el2)) {
          cur = secs[j];
          break;
        }
      }
    }
    var newActiveLink = null;
    nLinks.forEach(function(a) {
      var href = a.getAttribute('href') || '';
      var hash = ('#' + (href.split('#')[1] || '')).toLowerCase();
      var targetHash = cur ? '#' + cur : '';
      var isActive = hash === targetHash || (cur === '' && (hash === '#top' || hash === '#'));
      a.classList.toggle('active', isActive);
      if (isActive) newActiveLink = a;
    });
    if (newActiveLink && newActiveLink !== lastActiveLink) {
      lastActiveLink = newActiveLink;
      scrollActiveToCenter(newActiveLink);
    }
  }

  window.addEventListener('scroll', updateNav, { passive: true });
  window.addEventListener('load', updateNav);
  window.addEventListener('hashchange', function() { setTimeout(updateNav, 150); });
  updateNav();
})();
